import script from "./Sellers.vue?vue&type=script&setup=true&lang=js"
export * from "./Sellers.vue?vue&type=script&setup=true&lang=js"

import "./Sellers.vue?vue&type=style&index=0&id=496dfa6e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-496dfa6e"]])

export default __exports__